import { Config, FRDevice } from '@forgerock/javascript-sdk'
import { WEB_OAUTH_CLIENT } from '~utils/constants'

const selectIdpFlow = false
let token = ''
const selectedIdp = ''

const addJwtMiddleware = (req, action, next) => {
  if (action.type.toLowerCase().includes('authenticate')) {
    req.init.headers.append('session-jwt', token)
    if (selectIdpFlow) {
      req.init.headers.append('selected-idp', selectedIdp)
    }
  }
  next()
}

const forceAuthMiddleware = (req, action, next) => {
  req.url.searchParams.set('resourceName', 'SCDAUTHEAWSLOGINRES')
  switch (action.type) {
    case 'START_AUTHENTICATE':
      req.url.searchParams.set('ForceAuth', 'true')
      break
  }
  next()
}

export const decodeToken = (encodedToken: string) => JSON.parse(atob(encodedToken.split('.')[1]))

export const getPayload = () => {
  if (token) {
    return decodeToken(token)
  }
  return undefined
}

export const initAuth = (journey: string, storeToken: string, frEndPoint: string) => {
  if (storeToken) {
    token = storeToken
    const payload = getPayload()

    const realmPath = '/' + payload?.['segCX']

    //const realmPath = '/awm'
    Config.set({
      clientId: WEB_OAUTH_CLIENT,
      middleware: [forceAuthMiddleware, addJwtMiddleware],
      serverConfig: {
        baseUrl: frEndPoint,
        timeout: 50000,
      },
      realmPath: realmPath,
      tree: journey,
    })
  }
}

export const checkPingTokenExpiry = () => {
  const payloadData = getPayload()
  const expiryDate = new Date(payloadData?.exp * 1000)
  const currentDate = new Date()
  return expiryDate < currentDate
}

export const getDeviceProfile = async cb => {
  const isLocationRequired = cb.isLocationRequired()
  const isMetadataRequired = cb.isMetadataRequired()

  const device = new FRDevice()

  return await device.getProfile({
    location: isLocationRequired,
    metadata: isMetadataRequired,
  })
}
